import styled, { css } from 'styled-components'
import { rem } from '../../utils/common'
import { merchantThemes } from '../Variable'

export const InstructionList = styled.ul`
	display: block;
	list-style-type: none;
	padding: 0;
	margin-top: ${rem(40)};
`
export const InstructionListItem = styled.li`
	position: relative;
	display: block;
	margin: 0 auto ${rem(20)} auto;
	font-size: ${rem(14)};
	color: ${({ theme }) => theme.color.grayTen};
	width: 70%;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`
export const InstructionListItemIndex = styled.div`
	position: absolute;
	width: ${rem(30)};
	height: ${rem(30)};
	border-radius: 50%;
	border: ${rem(1)} solid ${({ theme }) => theme.color.grayThree};
	left: ${rem(-44)};
	text-align: center;
	line-height: ${rem(27)};
	color: ${({ theme }) => theme.color.blackOne};
	font-size: ${rem(16)};
	font-weight: 600;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`
